/* ============================================================
   IMENHOF BLOOM — a11y-fixes.js
   Synchroon geladen vanuit de aankondigingssectie, dus dit draait
   vóór alle defer-scripts (theme.js).
   WCAG 2.2 AA-correcties:
   1) Aankondigingsbalk (SC 2.2.2): neemt de rotatie over van
      theme.js (data-announce wordt hier verwijderd voordat
      theme.js draait). Pauzeknop, pauze op hover/focus,
      respecteert prefers-reduced-motion en verbergt inactieve
      items voor screenreaders.
   2) Toast (SC 4.1.3): meldingen doorgeven aan een live region.
   3) Productgalerij: aria-current op de actieve thumbnail.
   ============================================================ */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Aankondigingsbalk ---- */
  [].forEach.call(document.querySelectorAll('[data-announce]'), function (box) {
    box.removeAttribute('data-announce'); /* theme.js slaat deze balk nu over */
    var items = box.querySelectorAll('.announce__item');
    var btn = box.querySelector('[data-announce-pause]');
    if (items.length < 2) { if (btn) btn.hidden = true; return; }
    [].forEach.call(items, function (el) {
      if (!el.classList.contains('is-active')) el.setAttribute('aria-hidden', 'true');
    });
    if (REDUCED) { if (btn) btn.hidden = true; return; }
    var i = 0, t = null;
    function step() {
      items[i].classList.remove('is-active');
      items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
      items[i].removeAttribute('aria-hidden');
    }
    function start() { if (!t && !box.classList.contains('is-paused')) t = setInterval(step, 4500); }
    function stop() { if (t) { clearInterval(t); t = null; } }
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', stop);
    box.addEventListener('focusout', start);
    if (btn) btn.addEventListener('click', function () {
      var p = box.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', p ? 'true' : 'false');
      btn.setAttribute('aria-label', p ? 'Hervat wisselende meldingen' : 'Pauzeer wisselende meldingen');
      if (p) stop(); else start();
    });
    start();
  });

  /* ---- 2. Toast -> live region ---- */
  function say(msg) {
    if (!msg) return;
    if (window.IMHAnnounce) { window.IMHAnnounce(msg); return; }
    var lr = document.getElementById('A11yToastLive');
    if (!lr) {
      lr = document.createElement('div');
      lr.id = 'A11yToastLive';
      lr.className = 'visually-hidden';
      lr.setAttribute('role', 'status');
      lr.setAttribute('aria-live', 'polite');
      document.body.appendChild(lr);
    }
    lr.textContent = '';
    setTimeout(function () { lr.textContent = msg; }, 60);
  }
  function watchToast(el) {
    if (el._a11yWatched) return;
    el._a11yWatched = true;
    new MutationObserver(function () {
      if (el.classList.contains('is-show')) say(el.textContent.replace(/^\u2713\s*/, '').trim());
    }).observe(el, { attributes: true, attributeFilter: ['class'], childList: true });
  }
  function initToasts() {
    [].forEach.call(document.querySelectorAll('.toast'), watchToast);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        [].forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1 && n.classList && n.classList.contains('toast')) watchToast(n);
        });
      });
    }).observe(document.body, { childList: true });
  }

  /* ---- 3. Galerij: aria-current op actieve thumbnail ---- */
  function initGallery() {
    [].forEach.call(document.querySelectorAll('.gallery__thumb'), function (th) {
      function sync() {
        if (th.classList.contains('is-active')) th.setAttribute('aria-current', 'true');
        else th.removeAttribute('aria-current');
      }
      new MutationObserver(sync).observe(th, { attributes: true, attributeFilter: ['class'] });
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initToasts(); initGallery(); });
  } else { initToasts(); initGallery(); }
})();
